import { useState } from 'react';
import { CompaniesTable } from './CompaniesTable';
import { ManageCompany } from './ManageCompany';
import { toast, ToastContainer } from 'react-toastify';

export const CompaniesComponent = () => {
  const [modalOn, setModalOn] = useState(false);
  const [manageCompanyId, setManageCompanyId] = useState<string | number | undefined>(undefined);

  const toastMessage = (message: string) => {
    toast.success(message, {
      theme: 'colored',
      autoClose: 5000,
    });
  };

  return (
    <>
      {modalOn && (
        <ManageCompany
          setManageCompanyId={setManageCompanyId}
          companyId={manageCompanyId}
          setModalOn={setModalOn}
          toastMessage={toastMessage}
        ></ManageCompany>
      )}

      <div className='simply-header margin-left-2 margin-bottom-1 margin-top-3'>
        <button onClick={() => setModalOn(true)} className='simply-header__button button-primary font-h5-medium margin-right-1'>
          New Company
        </button>
        <h2 className='font-h2-medium'>Companies</h2>
      </div>
      <CompaniesTable setManageCompanyId={setManageCompanyId} setModalOn={setModalOn} />

      <ToastContainer
        position='bottom-center'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};
